const pagination =
{
    first    : 'Première' ,
    last     : 'Dernière' ,
    next     : 'Suivante' ,
    pages    : 'Page {0}/{1}',
    previous : 'Précédente'
};

export default pagination ;